import axios from 'axios'
import { BASE_URL_API as baseUrl } from 'utils/helpers'
import { toggleScaledDashboard } from 'store/user/actions'
import AxiosInstance from 'utils/AxiosInstance'
import * as types from './types'

const Axios = axios.create({
  baseURL: baseUrl(),
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
})

export const setLayouts = (layouts) => {
  console.log('Setting current dashboard data:', layouts)
  return {
    type: 'SET_LAYOUTS',
    payload: layouts,
  }
}

export const setCurrentBreakpoint = (breakpoint) => ({
  type: 'SET_CURRENT_BREAKPOINT',
  payload: breakpoint,
})
export const setEditBreakpoint = (breakpoint) => ({
  type: 'SET_EDIT_BREAKPOINT',
  payload: breakpoint,
})

export const skipLocations = () => {
  return { type: types.SET_SKIP_LOCATIONS }
}

export const setSkipLocations = (value) => {
  return { type: types.SET_SPECIFIC_SKIP_LOCATIONS, payload: value }
}

export const resetSkip = () => {
  return { type: types.RESET_SKIP }
}

export const setToolbox = (toolbox) => ({
  type: 'SET_TOOLBOX',
  payload: toolbox,
})

export const setDashboards = (dashboards) => ({
  type: 'SET_DASHBOARDS',
  payload: dashboards,
})

export const setCurrentDashboardId = (id) => {
  console.log('Setting current dashboard ID:', id)
  return {
    type: 'SET_CURRENT_DASHBOARD_ID',
    payload: id,
  }
}

export const setSavingLayout = (saving) => ({
  type: 'SET_SAVING_LAYOUT',
  payload: saving,
})

export const updateLayout = (newItem, currentBreakpoint, prevState) => ({
  type: 'UPDATE_LAYOUT',
  payload: { newItem, currentBreakpoint, prevState },
})

export const saveLayout = () => (dispatch, getState) => {
  const { layouts, currentDashboardId, toolbox, dashboards } =
    getState().dashboard
  dispatch(setSavingLayout(true))
  AxiosInstance.patch(
    '/users/update-layout',
    {
      layouts,
      id: currentDashboardId,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  )
    .then(() => {
      dispatch(setSavingLayout(false))
      dispatch(toggleScaledDashboard(false))
    })
    .catch((error) => {
      console.error('Error updating layout:', error)
    })

  AxiosInstance.patch(
    '/users/update-toolbox',
    {
      toolbox: toolbox,
      id: currentDashboardId,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }
  )
    .then((response) => {
      dispatch(setSavingLayout(false))
    })
    .catch((error) => {
      console.error('Error updating layout:', error)
    })

  const updatedDashboard = dashboards.map((item) => {
    if (item.id === currentDashboardId) {
      return {
        ...item,
        data: JSON.stringify(layouts),
        toolbox: JSON.stringify(toolbox),
      }
    }
    return item
  })

  dispatch(setDashboards(updatedDashboard))
}

export const handleToggleItem = (item) => (dispatch, getState) => {
  const { toolbox, layouts, currentBreakpoint } = getState().dashboard
  const updatedToolbox = toolbox
    ?.map((toolbox) => convertObjectDataTypes(toolbox))
    ?.map((toolboxItem) =>
      toolboxItem.id === item.id
        ? { ...toolboxItem, active: !toolboxItem.active }
        : toolboxItem
    )
  dispatch(setToolbox(updatedToolbox))

  dispatch(updateLayout(item, currentBreakpoint, { ...layouts }))
}

export const handleCancel = () => (dispatch, getState) => {
  const { dashboards } = getState().dashboard

  const data = dashboards[0].data
  const layouts = {
    lg: [...data.lg],
    md: [...data[data.md ? 'md' : 'lg']],
    sm: [...data[data.sm ? 'sm' : 'lg']],
  }

  dispatch(setEditBreakpoint('lg'))
  dispatch(setLayouts(layouts))
  dispatch(setToolbox(dashboards[0].toolbox))
  dispatch(setCurrentDashboardId(1))
}

function convertObjectDataTypes(obj) {
  const layout = { ...obj.layout }
  for (const key in layout) {
    if (key !== 'i') {
      const value =
        layout[key].toLowerCase && layout[key].toLowerCase() === 'false'
          ? false
          : Number(layout[key])
      layout[key] = isNaN(value) ? layout[key] : value
    }
  }
  return {
    ...obj,
    active:
      typeof obj.active === 'boolean'
        ? obj.active
        : obj.active
        ? obj.active.toString().toLowerCase() === 'true'
        : false,
    layout,
  }
}

export const setWhereYouLeftFetched = (boolean) => ({
  type: types.SET_WHERE_YOU_LEFT_FETCHED,
  payload: boolean,
})

export const setWhereYouLeftData = (data) => ({
  type: types.SET_WHERE_YOU_LEFT_DATA,
  payload: data,
})

export const setCompletedCoursesFetched = (boolean) => ({
  type: types.SET_COMPLETED_COURSES_FETCHED,
  payload: boolean,
})

export const setCompletedCoursesData = (data) => ({
  type: types.SET_COMPLETED_COURSES,
  payload: data,
})

export const setMessagesFetched = (boolean) => ({
  type: types.SET_MESSAGES_FETCHED,
  payload: boolean,
})

export const setManagersOverviewFetched = (boolean) => ({
  type: types.SET_MANAGERS_OVERVIEW_FETCHED,
  payload: boolean,
})

export const setManagersOverview = (data) => ({
  type: types.SET_MANAGERS_OVERVIEW,
  payload: data,
})

export const setRewardsFetched = (boolean) => ({
  type: types.SET_REWARDS_FETCHED,
  payload: boolean,
})

export const setManagerApprovalFetched = (boolean) => ({
  type: types.SET_MANAGER_APPROVAL_FETCHED,
  payload: boolean,
})

export const setRewards = (data) => ({
  type: types.SET_REWARDS,
  payload: data,
})

export const setRestaurantProgressFetched = (boolean) => ({
  type: types.SET_RESTAURANT_PROGRESS_FETCHED,
  payload: boolean,
})

export const setRestaurantProgress = (data) => ({
  type: types.SET_RESTAURANT_PROGRESS,
  payload: data,
})

export const setPromotedCourses = (data) => ({
  type: types.SET_PROMOTED_COURSES,
  payload: data,
})

export const setCoursesOverviewFetched = (boolean) => ({
  type: types.SET_COURSES_OVERVIEW_FETCHED,
  payload: boolean,
})

export const setPromotedCoursesFetched = (boolean) => ({
  type: types.SET_PROMOTED_COURSES_FETCHED,
  payload: boolean,
})

export const setCoursesOverview = (data) => ({
  type: types.SET_COURSES_OVERVIEW,
  payload: data,
})

export function fetchCoursesOverview() {
  return async function (dispatch, getState) {
    if (
      getState().dashboard.coursesOverview.length !== 0 &&
      getState().dashboard.coursesOverviewState === 'fresh'
    )
      return

    dispatch({ type: types.SET_COURSES_OVERVIEW_LOADING })

    const res = await AxiosInstance.get('/users/self/course-overview')

    dispatch({ type: types.SET_COURSES_OVERVIEW, payload: res })
    dispatch({ type: types.SET_COURSES_OVERVIEW_FRESH })
  }
}

export function invalidateCoursesOverview() {
  return function (dispatch) {
    dispatch({ type: types.SET_COURSES_OVERVIEW_STALE })
    // dispatch(fetchCoursesOverview())
  }
}
